import {apiSlice} from './apiSlice';
import {
    TicketsData,
    UpdateTicketParams,
    FilterOptions,
    GetTicketsParams
} from '../../types/ticketTypes';

export const ticketsInjectedEndpoints = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        // Get tickets with pagination and optional filtering.
        getTickets: builder.query<TicketsData, GetTicketsParams>({
            query: ({page = 1, perPage = 10, filters}) => {
                const params = new URLSearchParams({
                    page: page.toString(),
                    per_page: perPage.toString(),
                    ...filters
                });
                return `/tickets?${params}`;
            },
            providesTags: ["Tickets"],
        }),
        updateTicket: builder.mutation<void, UpdateTicketParams>({
            query: ({ticketID, ticketData}) => {
                const ticketUpdateURL = `/tickets/${ticketID}`;
                return {
                    url: ticketUpdateURL,
                    method: 'PUT',
                    body: ticketData,
                };
            },
            invalidatesTags: ["Tickets"],
        }),
        getFilterOptions: builder.query<FilterOptions, void>({
            query: () => '/tickets/get_filter_options'
        }),
    }),
});

export const ticketsEndpoints = ticketsInjectedEndpoints.endpoints;
export const {
    useGetTicketsQuery,
    useUpdateTicketMutation,
    useGetFilterOptionsQuery,
} = ticketsInjectedEndpoints;
